import {
  alpha,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputBase,
  styled,
} from "@mui/material";
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import React, { useMemo } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import moment from "moment";
import {
  fetchLeaderboard,
  fetchUserCompetition,
} from "../../store/reducers/competitionReduder";
import { dollarUS } from "../../utilities/formatters";
import Pagination from "@mui/material/Pagination";
import Title from "../../components/ReusableComponents/title";
import SearchIcon from "@mui/icons-material/Search";
import { Cancel } from "@mui/icons-material";

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination
      color="primary"
      count={pageCount}
      page={page + 1}
      boundaryCount={2}
      showFirstButton
      showLastButton
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "10px",
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  background: "#222C3A",
  // '.MuiIconButton-root.MuiIconButton-sizeMedium:hover': {
  //     background: '#222C3A',
  //     borderBottomLeftRadius: 0,
  //     borderTopLeftRadius: 0,
  //     borderBottomRightRadius: '10px',
  //     borderTopRightRadius: '10px',
  // },
  [theme.breakpoints.up("sm")]: {
    marginLeft: 0,
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  borderRadius: "10px",
  pointerEvents: "none",
  display: "flex",
  background: "#222C3A",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    borderRadius: "10px",
    background: "#222C3A",
    [theme.breakpoints.up("md")]: {
      width: "55ch",
    },
  },
}));

const Table = ({
  handleClick,
  setCurrentWinner,
  setContestants,
  setUserData,
  loading,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    loading: true,
    rows: [],
    totalRows: 0,
    rowCount: 0,
    rowsPerPageOptions: [10, 50, 100],
    pageSize: 12,
    page: 1,
    nextPage: 0,
  });
  const [CompName, setCompName] = useState("");
  const [searchTxt, setSearchTxt] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const displayData = useMemo(() => {
    if (searchInput) {
      return data.rows.filter((row) => {
        return String(row.name)
          .toLowerCase()
          .includes(searchInput.toLowerCase().trim());
      });
    }
    return data.rows;
  }, [searchInput, data.rows]);

  const handleSearchClick = () => setSearchInput(searchTxt);

  const params = useParams();

  const updateData = (k, v) => setData((prev) => ({ ...prev, [k]: v }));

  function disableScroll() {
    document.body.style.overflow = "hidden";
  }
  function enableScroll() {
    document.body.style.overflow = "auto";
  }
  useEffect(() => {
    loading(true);
    disableScroll();
    updateData("loading", true);

    const competition_id = params.id ? params.id : "";
    dispatch(fetchLeaderboard(competition_id))
      .then((res) => {
        res.leaderboard.forEach((element, idx) => {
          element["rank"] = idx + 1;
        });
        dispatch(fetchUserCompetition(res.leaderboard[0].id))
          .then((res) => {
            setUserData(res);
            loading(false);
            enableScroll();
          })
          .catch((error) => {
            console.log(error);
            loading(false);
            enableScroll();
          });
        setContestants(res.leaderboard.length);
        setCurrentWinner(res.leaderboard[0].name);
        updateData("rows", res.leaderboard);
        setCompName(
          res.leaderboard.length ? res.leaderboard[0].competition_name : ""
        );
        updateData("loading", false);
        loading(false);
        enableScroll();
      })
      .catch((err) => {
        console.log(err);
        updateData("loading", false);
      });
  }, [params.id]);

  return (
    <Grid xs={12}>
      <div
        className="Container-p-20 leaderboard-ctn"
        style={{ borderRadius: "10px" }}
      >
        <Title six>Competition leaderboard {`| ${CompName}`}</Title>

        <div
        className="search_bar"
          style={{
            display: "flex",
            flexDirection: "row",
            margin: "10px 0",
            color: "#FFF",
          }}
        >
          <Search>
            <SearchIconWrapper>
              <SearchIcon sx={{ zIndex: "1" }} />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search by name"
              inputProps={{ "aria-label": "search" }}
              value={searchTxt}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSearchClick();
              }}
              onChange={(e) => {
                setSearchTxt(e.target.value);
                if (e.target.value === "") setSearchInput("");
              }}
              endAdornment={
                searchTxt && (
                  <IconButton
                    aria-label="toggle search clear button"
                    onClick={() => {
                      setSearchInput("");
                      setSearchTxt("");
                    }}
                  >
                    <Cancel />
                  </IconButton>
                )
              }
            />
          </Search>
          <Button variant="outlined" onClick={handleSearchClick}>
            Search
          </Button>
        </div>
        <div style={{ height: "875px" }}>
          <DataGrid
            pageSize={data.pageSize}
            onPageSizeChange={(newPageSize) =>
              updateData("pageSize", newPageSize)
            }
            rowsPerPageOptions={data.rowsPerPageOptions}
            pagination
            disableSelectionOnClick
            disableColumnMenu
            className="leaderboard-table"
            rowHeight={50}
            loading={data.loading}
            rows={displayData}
            components={{
              Pagination: CustomPagination,
            }}
            columns={[
              {
                field: "rank",
                headerName: "#",
                // width: 50,
                sortable: false,
                renderCell: (params) => {
                  return params.value;
                },
              },
              {
                field: "name",
                // width: 110,
                sortable: false,
                headerName: "Name",
              },
              {
                field: "date",
                // width: 130,
                sortable: false,
                renderHeader: (params) => "Date",
                valueGetter: (params) =>
                  moment(params.value).format("Do MMM yy"),
              },
              {
                field: "balance_equity",
                // width: 130,
                sortable: false,
                renderHeader: (params) => "Account Balance",
                valueGetter: (params) => dollarUS(params.value.balance),
              },
              {
                field: "is_disqualified",
                // width: 130,
                sortable: false,
                headerName: "Status",
                valueGetter: (params) => (params.value ? "Inactive" : "Active"),
              },
              {
                field: "prizes",
                // width: 130,
                sortable: false,
                headerName: "Prize won",
                valueGetter: (params) => (params.value ? params.value : ""),
              },
              {
                field: "action",
                // width: 130,
                sortable: false,
                headerName: "Action",
                renderCell: (params) => {
                  return (
                    <Button onClick={(e) => handleClick(params.row.id)}>
                      View Details
                    </Button>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </Grid>
  );
};

export default Table;
